"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateFormat = DateFormat;

var _moment = _interopRequireDefault(require("moment"));

function DateFormat(params) {
  return new Intl.DateTimeFormat(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }).format(_moment["default"].utc(params.value).toDate());
}